import { useTranslation } from 'react-i18next';
import './style.scss';

import { dateFormatter } from '@global/utils/date';
import { useMemo } from 'react';
import { SiteConfig } from '@src/global/utils/SiteConfig';

interface OrderInfoProps {
  placementDate: string;
  orderNumber: string;
}

export const OrderInfo = ({ placementDate, orderNumber }: OrderInfoProps) => {
  const { t } = useTranslation();
  const { locale } = SiteConfig.getConfig();

  const formattedPlacementDate = useMemo(() => {
    return dateFormatter(placementDate, locale);
  }, [locale, placementDate]);

  return (
    <div className="order-info">
      <div>
        <p className="order-info__column-header">
          {t('confirmation.details.orderPlaced')}
        </p>
        <p className="order-info__column-value">{formattedPlacementDate}</p>
      </div>
      <div>
        <p className="order-info__column-header">
          {t('confirmation.details.orderNumber')}
        </p>
        <p className="order-info__column-value">{orderNumber}</p>
      </div>
    </div>
  );
};
